import React, { useEffect, useState } from 'react';
import { useDataContext } from 'common/lib/helpers/DataContext';
import PropTypes from 'prop-types';
import KnipsModule from './KnipsModule';
import ContentModule from '../contentModule';

const ExternalContent = ({ finnkode, contentModule }) => {
    const { enableKnips, layoutPath, knipsContentUrl } = useDataContext('ad-data');

    const [data, setData] = useState(null);
    const [isLoadingKnips, setIsLoadingKnips] = useState(false);

    useEffect(() => {
        if (enableKnips) {
            setIsLoadingKnips(true);
            fetch(`${layoutPath}/knips/${finnkode}`)
                .then(res => res.json())
                .then(knipsData => {
                    setData(knipsData);
                    setIsLoadingKnips(false);
                })
                .catch(() => {
                    setData(null);
                    setIsLoadingKnips(false);
                });
        }
    }, []);

    const hasKnipsIntegration = () => data && data.knipsId && data.knipsId.length > 0;

    if (isLoadingKnips) return null;
    if (enableKnips && hasKnipsIntegration())
        return <KnipsModule finnkode={finnkode} knipsId={data.knipsId} knipsContentUrl={knipsContentUrl} />;
    return <ContentModule contentModule={contentModule} />;
};

ExternalContent.propTypes = {
    finnkode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    contentModule: PropTypes.object,
};

export default ExternalContent;
